export var EAccountOnboardingSetupStepType = /*#__PURE__*/function (EAccountOnboardingSetupStepType) {
  EAccountOnboardingSetupStepType["A2PRegistration"] = "a2pRegistration";
  EAccountOnboardingSetupStepType["NumberAssignment"] = "numberAssignment";
  EAccountOnboardingSetupStepType["IntegratorSetup"] = "integratiorSetup";
  EAccountOnboardingSetupStepType["Provisioning"] = "provisioning";
  EAccountOnboardingSetupStepType["TimezoneSetup"] = "timezoneSetup";
  EAccountOnboardingSetupStepType["Quickstarts"] = "quickstarts";
  return EAccountOnboardingSetupStepType;
}({});
export var EAccountOnboardingSetupStepStatus = /*#__PURE__*/function (EAccountOnboardingSetupStepStatus) {
  EAccountOnboardingSetupStepStatus["NotStarted"] = "not-started";
  EAccountOnboardingSetupStepStatus["NotApplicable"] = "not-applicable";
  EAccountOnboardingSetupStepStatus["InProgress"] = "in-progress";
  EAccountOnboardingSetupStepStatus["Completed"] = "completed";
  EAccountOnboardingSetupStepStatus["Failed"] = "failed";
  return EAccountOnboardingSetupStepStatus;
}({});
export var EAccountOnboardingChecklistStatus = /*#__PURE__*/function (EAccountOnboardingChecklistStatus) {
  EAccountOnboardingChecklistStatus["NotStarted"] = "not-started";
  EAccountOnboardingChecklistStatus["InProgress"] = "in-progress";
  EAccountOnboardingChecklistStatus["Completed"] = "completed";
  EAccountOnboardingChecklistStatus["Blocked"] = "blocked";
  return EAccountOnboardingChecklistStatus;
}({});
export var EEHR = /*#__PURE__*/function (EEHR) {
  EEHR["Adspm"] = "adspm";
  EEHR["Advancedmd"] = "advancedmd";
  EEHR["Allscriptspm"] = "allscriptspm";
  EEHR["Allscriptsunity"] = "allscriptsunity";
  EEHR["Amazingcharts"] = "amazingcharts";
  EEHR["Athenahealth"] = "athenahealth";
  EEHR["Athenamdp"] = "athenamdp";
  EEHR["Carecloud"] = "carecloud";
  EEHR["Centricityps"] = "centricityps";
  EEHR["Cerner"] = "cerner";
  EEHR["Clinicient"] = "clinicient";
  EEHR["Curemd"] = "curemd";
  EEHR["Drchrono"] = "drchrono";
  EEHR["Eclinicalmobile"] = "eclinicalmobile";
  EEHR["Eclinicalworks10e"] = "eclinicalworks10e";
  EEHR["Eclinicalworkssql"] = "eclinicalworkssql";
  EEHR["Ellkay"] = "ellkay";
  EEHR["Emds"] = "emds";
  EEHR["Epic"] = "epic";
  EEHR["Genericfhir"] = "genericfhir";
  EEHR["Ggastromobile"] = "ggastromobile";
  EEHR["Greenwayintergy"] = "greenwayintergy";
  EEHR["Greenwayprimesuite"] = "greenwayprimesuite";
  EEHR["Greenwayprimesuiteapi"] = "greenwayprimesuiteapi";
  EEHR["Imedicware"] = "imedicware";
  EEHR["Isalus"] = "isalus";
  EEHR["Kareo"] = "kareo";
  EEHR["Keymedical"] = "keymedical";
  EEHR["Lumacare"] = "lumacare";
  EEHR["Lumaload"] = "lumaload";
  EEHR["Lumamock"] = "lumamock";
  EEHR["Lyniate"] = "lyniate";
  EEHR["Mdoffice"] = "mdoffice";
  EEHR["Medicalmastermind"] = "medicalmastermind";
  EEHR["Medinformatix"] = "medinformatix";
  EEHR["Meditechexpanse"] = "meditechexpanse";
  EEHR["Medstreaming"] = "medstreaming";
  EEHR["Mi7"] = "mi7";
  EEHR["Modmedfhir"] = "modmedfhir";
  EEHR["Nextech"] = "nextech";
  EEHR["Nextechfhir"] = "nextechfhir";
  EEHR["Nextechpracticeplus"] = "nextechpracticeplus";
  EEHR["Nextgen"] = "nextgen";
  EEHR["Nextgenapi"] = "nextgenapi";
  EEHR["Oncoemrfilepickup"] = "oncoemrfilepickup";
  EEHR["Roche"] = "roche";
  EEHR["Systemedx"] = "systemedx";
  EEHR["Webpt"] = "webpt";
  return EEHR;
}({});